import { Layers } from "lucide-react";

function StatCard({ title, count, icon: Icon = Layers }) {
  return (
    <div
      className="
        rounded
        bg-gradient-to-br from-blue-600/20 to-indigo-600/20
        border border-blue-500/20
        p-3
        w-full
        shadow-md
        flex
        items-center
        justify-between
      "
    >
      <div>
        <p className="text-slate-400 text-xs">{title}</p>

        <h2 className="mt-1 text-2xl font-black text-white">{count ?? 0}</h2>
      </div>

      <div
        className="
          w-10
          h-10
          rounded-xl
          bg-blue-500/20
          flex
          items-center
          justify-center
        "
      >
        <Icon size={22} className="text-blue-300" />
      </div>
    </div>
  );
}

export default StatCard;
